/** @format */

import React from 'react';

import { useLocation } from 'react-router';

import ProtectedRoutes from '../Routes/ProtectedRoutes';
import RestrictedRoutes from '../Routes/RestrictedRoutes';
import { checkLogin } from '../Shared/hooks/authenticate';

const App = () => {
  const { pathname } = useLocation();
  return checkLogin() ? (
    <ProtectedRoutes key={pathname} />
  ) : (
    <RestrictedRoutes key={pathname} />
  );
};

export default App;
